import type { CreateReagentLotInput } from '#shared/types';
import { api } from '#client/lib/api';
import { RESOURCE } from '#client/lib/routes';

/** Enters stock — an opening balance or an off-order delivery. */
export function enterStock(input: CreateReagentLotInput): Promise<unknown> {
  return api.post(RESOURCE.reagentLots, input);
}
